























































































import ClientProductSearch from "@/components/ClientProductSearch.vue";
import EntryItem from "@/components/EntryItem.vue";
import SaveButton from "@/components/SaveButton.vue";
import { ClientAgentProduct, ProfileAssociation } from "@/models";
import { formatDateDDMMYYYY } from "@/utils/Date";
import { Component, Prop, Vue } from "vue-property-decorator";

export type ProductSelectEvent = {
  product: ClientAgentProduct;
  profileAssociation: ProfileAssociation;
};

@Component({
  components: {
    ClientProductSearch,
    EntryItem,
    SaveButton,
  },
})
export default class ProfilesAssociationByProductProductsTable extends Vue {
  @Prop({ default: () => [] })
  readonly profileAssociations!: ProfileAssociation[];

  get shownProfileAssociations(): ProfileAssociation[] {
    return this.profileAssociations.filter((el) => !el.ignored);
  }

  get ignoredAssociationsText(): string {
    const count = this.profileAssociations.filter((p) => p.ignored).length;

    if (count === 0) {
      return "Nessun prodotto ignorato";
    }

    return count === 1 ? "1 prodotto ignorato" : `${count} prodotti ignorati`;
  }

  formatDate(date: string): string {
    return formatDateDDMMYYYY(date);
  }

  onProductSelected(
    product: ClientAgentProduct,
    profileAssociation: ProfileAssociation
  ): void {
    this.$emit("product-selected", { product, profileAssociation });
  }

  onProductSearch(association: ProfileAssociation): void {
    this.$emit("product-search", association);
  }

  onIgnore(association: ProfileAssociation): void {
    this.$emit("ignore", association);
  }

  onMatchAssociations(): void {
    this.$emit("match-products");
  }

  onSearchCleared(association: ProfileAssociation): void {
    this.$emit("search-cleared", association);
  }
}
